import i18n from 'src/i18n';

const configTable = () => ({
  tableColumns: [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 160,
      sortable: true,
    },
    {
      prop: 'brand',
      label: i18n.t('devices.brand'),
      minWidth: 130,
      sortable: true,
    },
    {
      prop: 'model',
      label: i18n.t('devices.model'),
      minWidth: 130,
      sortable: true,
    },
    {
      prop: 'serial_number',
      label: i18n.t('devices.serial_number'),
      minWidth: 160,
      sortable: true,
    },
    {
      prop: 'indicator_mac',
      label: i18n.t('devices.indicator_mac'),
      minWidth: 180,
      sortable: true,
    },
    {
      prop: 'location',
      label: i18n.t('common_words.location'),
      minWidth: 160,
      sortable: true,
    },
  ],
});

export default configTable;
